import { AxiosResponse } from 'axios';

/**
 * Intened to be an implementation-agnostic wrapper for HTTP errors.
 * Hopefully this helps us smooth the transition from axios to fetch
 *
 * NOTE(Ryan): There is an existing HttpError impl at @rover/utilities/HttpError
 *             that mostly controls displaying error pages on SSR. We can eventually
 *             migrate that logic here but I'm considering it out of scope for now.
 */
export default class HttpError extends Error {
  rawResponse?: AxiosResponse<unknown>;

  statusCode: number;

  // NOTE(Ryan) also accepting a number is a temp measure while I think about this more
  constructor(public res: AxiosResponse<unknown> | number) {
    super(`HTTP Error ${typeof res === 'number' ? res : res.status}`);

    this.name = 'HttpError';

    if (typeof res === 'number') {
      this.statusCode = res;
    } else {
      this.rawResponse = res;
      this.statusCode = res.status;
    }

    // Set the prototype explicitly, see https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    // extending classes will also need to do this
    Object.setPrototypeOf(this, HttpError.prototype);
  }
}
